import { iconsLibrary } from "../elements/icons-library";
const iconResolver = {
    // the type requires a name here but it doesn't appear to be used
    name: "",
    resolver: (name) => {
        if (!(name in iconsLibrary)) {
            // eslint-disable-next-line no-console
            console.debug(`icon "${String(name)}" doesn't exist`);
            return "";
        }
        return `data:image/svg+xml,${encodeURIComponent(
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconsLibrary[name])}`;
    },
    mutator: (svg) => {
        svg.setAttribute("fill", "currentColor");
    },
};
export { iconResolver };
